import { Schema } from './get_schema.js';

const id = Schema.Int;
const name = Schema.NotEmptyString;
const avatar = Schema.String;
const email = Schema.Email;
const pwd = Schema.NotEmptyString;
const hash = Schema.FixedString(32);
const invited_by = Schema.String;
const rights = Schema.Enum('admin', 'moderator', '');
const flag_bit = Schema.Int;
const subject = Schema.String;
const message = Schema.String;
const dataset = Schema.Enum('default', 'blank');

const schemaFields = {
  id,
  name,
  avatar,
  email,
  pwd,
  hash,
  invited_by,
  rights,
  flag_bit,
  userId: id,
  dataset,
};

const schema = {
  'login': new Schema({
    email,
    pwd,
  }),
  'cancel-password-recovery': new Schema({
    hash,
  }),
  'check-password-recovery-hash': new Schema({
    hash,
  }),
  'contact-us': new Schema({
    name,
    email,
    subject,
    message,
  }),
  'identify': new Schema({}),
  'recover-password': new Schema({
    email,
  }),
  'reset-password': new Schema({
    hash,
    pwd,
  }),
  'signup': new Schema({
    name,
    email,
    pwd,
  }),
};

export { schema as AccountSchema, schemaFields as AccountSchemaFields };
